import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import './index.css'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content:
            'Innovation is the product of action. But action can be hard, and the barriers to innovation can seem insurmountable. Here are 6 ways to start. What’s stopping you?',
        },
        { name: 'keywords', content: 'innovation' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: '6 Tips to Help You Innovate' },
        {
          name: 'twitter:description',
          content:
            'We asked employees from a range of industries what stops them from innovating at work. Here’s what they said, along with some tips to get make an impact.',
        },
        { name: 'twitter:site', content: '@zeusjones' },
        {
          name: 'twitter:image:src',
          content: 'https://innovation.zeusjones.com/social.jpg',
        },
        { property: 'og:title', content: '6 Tips to Help You Innovate' },
        {
          property: 'og:description',
          content:
            'We asked employees from a range of industries what stops them from innovating at work. Here’s what they said, along with some tips to get make an impact.',
        },
        {
          property: 'og:image',
          content: 'https://innovation.zeusjones.com/social.jpg',
        },
        { property: 'og:url', content: 'https://innovation.zeusjones.com' },
        { property: 'og:site_name', content: '6 Tips to Help You Innovate' },
        { property: 'og:type', content: 'website' },
      ]}
    />
    {children()}
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js